import React from 'react';
export const KpiReadyDocsIcon = () => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none" },
    React.createElement("path", { d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z", stroke: "#12B981", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
